document.addEventListener('DOMContentLoaded', function() {

  const icons = [
    'chi-01.svg', 'chi-02.svg', 'chi-03.svg', 'chi-04.svg',
    'chi-05.svg', 'chi-06.svg', 'chi-07.svg', 'chi-08.svg',
    'chi-09.svg', 'chi-10.svg', 'chi-11.svg', 'chi-12.svg',
    'chi-13.svg', 'chi-14.svg', 'chi-15.svg', 'chi-16.svg'
  ];

  const backgroundColors = [
    '#78438F', '#7BAB64', '#3BA7A9', '#ECDE26',
    '#6DA1CF', '#8A5424', '#C991B5', '#7F98C2',
    '#DD5022', '#2B9AC3', '#14924A', '#4A66A0',
    '#F7BB8E', '#D0C262', '#A49ABF', '#F29C80'
  ];

  const mainImage = document.getElementById('mainImage');
  const iconContainer = document.querySelector('.icon-container');

  // デバウンス用のタイマー
  let resizeTimer = null;

  // 現在の画像インデックスを追跡
  let currentOddIndex = 0;
  let currentEvenIndex = 0;

  // 振り子アニメーション用の状態管理
  let pendulumState = 0;

  // アニメーション制御用
  let animationTimer = null;
  let animationStartTime = null;
  let lastUpdateTime = 0;
  let lastIconUpdateTime = 0;

  // パスサイズを動的に調整
  function updatePathSize() {
    const containerWidth = iconContainer.offsetWidth;
    const containerHeight = iconContainer.offsetHeight;

    const originalWidth = 757;
    const originalHeight = 756;
    const aspectRatio = originalHeight / originalWidth;

    // パスの横幅設定
    const isMobile = window.innerWidth <= 999;
    const newWidth = isMobile ? containerWidth : containerWidth * 1.01;
    const newHeight = newWidth * aspectRatio;

    // スケール係数を計算
    const scaleX = newWidth / originalWidth;
    const scaleY = newHeight / originalHeight;

    // 上下中央配置
    const yOffset = (containerHeight - newHeight) / 2;
    const xOffset = (containerWidth - newWidth) / 2;

    // SPの中心位置を調整
    let adjustedYOffset = yOffset;
    let adjustedXOffset = xOffset;
    if (isMobile) {
      adjustedYOffset = yOffset + (25 * scaleY);
      adjustedXOffset = xOffset + (70 * scaleX);
    }

    // SPの入・出の位置を調整
    let startY, endY;
    if (isMobile) {
      startY = (-140 * scaleY) + adjustedYOffset;
      endY = (996 * scaleY) + adjustedYOffset;
    } else {
      startY = (-100 * scaleY) + yOffset;
      endY = (856 * scaleY) + yOffset;
    }

    // スケールされた円弧パスの生成
    const scaledPath = `M ${(756.5 * scaleX) + adjustedXOffset} ${startY} c ${0 * scaleX} ${308.76 * scaleY} ${-169.24 * scaleX} ${478 * scaleY} ${-378 * scaleX} ${478 * scaleY} S ${(0.5 * scaleX) + adjustedXOffset} ${(647.24 * scaleY) + adjustedYOffset} ${(0.5 * scaleX) + adjustedXOffset} ${endY}`;

    document.documentElement.style.setProperty('--dynamic-path', `path('${scaledPath}')`);

    return scaledPath;
  }

  function handleResize() {
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(() => {
      updatePathSize();
    }, 100);
  }

  window.addEventListener('resize', handleResize);

  // 振り子アニメーションのクラス切り替え
  function updatePendulum() {
    iconContainer.classList.remove('swing-right', 'swing-left');

    switch (pendulumState) {
      case 0:
        iconContainer.classList.add('swing-right');
        break;
      case 1:
        iconContainer.classList.add('swing-left');
        break;
    }

    pendulumState = (pendulumState + 1) % 2;
  }

  // アイコンパスを取得
  function getIconPath(iconName) {
    return `${window.location.origin}/wp/wp-content/themes/origin/assets/image/about/${iconName}`;
  }

  function init() {
    for (let i = 0; i < 2; i++) {
      const groupElements = iconContainer.querySelectorAll(`[data-icon-index="${i}"]`);
      const iconPath = getIconPath(icons[i]);
      groupElements.forEach(icon => {
        icon.src = iconPath;
      });
    }

    const firstIcon = iconContainer.querySelector('.icon-1[data-icon-index="0"]');
    if (firstIcon) {
      const isMobile = window.innerWidth <= 999;
      const animationName = isMobile ? 'icon-animation' : 'icon-animation-from-10';

      setTimeout(() => {
        firstIcon.style.animation = `${animationName} 12s cubic-bezier(.73,.76,.23,.12) infinite`;
      });
    }

    updateBackgroundColor(backgroundColors[0]);

    setTimeout(() => {
      updateBackgroundColor(backgroundColors[1]);
    }, 6000);

    updatePathSize();
    updatePendulum();
  }

  function startAnimation() {
    init();

    animationStartTime = Date.now();
    lastUpdateTime = 0;
    lastIconUpdateTime = 0;

    function animationLoop() {
      const currentTime = Date.now();
      const elapsedTime = currentTime - animationStartTime;

      const cycleTime = 12000;
      const currentCycle = Math.floor(elapsedTime / cycleTime);

      if (currentCycle > lastUpdateTime) {
        lastUpdateTime = currentCycle;
        updateIconImage(0);
        updatePendulum();
        lastIconUpdateTime = currentTime;
      }

      if (lastIconUpdateTime > 0 && (currentTime - lastIconUpdateTime) >= 6000) {
        updateIconImage(1);
        lastIconUpdateTime = 0;
      }

      animationTimer = requestAnimationFrame(animationLoop);
    }

    animationLoop();
  }

  // 個別のアイコン画像を更新
  function updateIconImage(groupIndex) {
    const groupElements = iconContainer.querySelectorAll(`[data-icon-index="${groupIndex}"]`);

    if (groupElements.length > 0) {
      let nextIconIndex;

      if (groupIndex === 0) {
        const oddIndices = [0, 2, 4, 6, 8, 10, 12, 14];
        currentOddIndex = (currentOddIndex + 1) % oddIndices.length;
        nextIconIndex = oddIndices[currentOddIndex];
      } else {
        const evenIndices = [1, 3, 5, 7, 9, 11, 13, 15];
        currentEvenIndex = (currentEvenIndex + 1) % evenIndices.length;
        nextIconIndex = evenIndices[currentEvenIndex];
      }

      const nextIconPath = getIconPath(icons[nextIconIndex]);

      groupElements.forEach((icon) => {
        icon.src = nextIconPath;

        if (groupIndex === 0 && currentOddIndex === 0) {
          const isMobile = window.innerWidth <= 999;
          const animationName = isMobile ? 'icon-animation-from' : 'icon-animation-from-10';
          setTimeout(() => {
            icon.style.animation = `${animationName} 12s cubic-bezier(.73,.76,.23,.12) infinite`;
          });
        } else {
          icon.style.animation = 'none';
          setTimeout(() => {
            icon.style.animation = 'icon-animation 12s cubic-bezier(.73,.76,.23,.12) infinite';
          });
        }
      });

      updateBackgroundColor(backgroundColors[nextIconIndex]);
    }
  }

  // 背景色を更新
  function updateBackgroundColor(color) {
    const currentColor = mainImage.style.backgroundColor;

    if (currentColor === color) {
      return;
    }

    requestAnimationFrame(() => {
      mainImage.offsetHeight;

      mainImage.style.backgroundColor = color;
    });
  }

  startAnimation();
});

